let STORAGE_SESSION_ID_KEY = "sessionId";
function generateRandomId() {
  return Math.random().toString(36).slice(2, 20);
}
function generateRandomGUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}
function initializeSessionId({ storageSessionIdKey = STORAGE_SESSION_ID_KEY, uuid = false }) {
  STORAGE_SESSION_ID_KEY = storageSessionIdKey;
  const sessionId = sessionStorage.getItem(storageSessionIdKey);
  if (!sessionId) {
    sessionStorage.setItem(storageSessionIdKey, uuid ? generateRandomGUID() : generateRandomId());
  }
  return sessionStorage.getItem(storageSessionIdKey);
}
function getSessionId() {
  if (!STORAGE_SESSION_ID_KEY) {
    throw new Error("Session ID key is not initialized. Please call initializeSessionId() first.");
  }
  return sessionStorage.getItem(STORAGE_SESSION_ID_KEY);
}
export {
  STORAGE_SESSION_ID_KEY as S,
  generateRandomId as a,
  generateRandomGUID as b,
  getSessionId as g,
  initializeSessionId as i
};
//# sourceMappingURL=userSessionId-sBB4fImL.js.map
